// services/statsService.ts — the landing page's public counters (1.24.70).
//
// One anonymous GET. The numbers are real, cached server-side for 5 minutes
// (see backend apps/content/stats.py). The landing page treats failure as
// "show nothing numeric" — it must render fine without this endpoint, so the
// service just rethrows and the caller degrades.

import { api } from '@/core/lib/apiClient';

export interface SiteStats {
  members: number;
  posts: number;
  verdicts: number;
}

export const statsService = {
  fetchSiteStats(): Promise<SiteStats> {
    return api<SiteStats>('/stats/');
  },
};
